import { SimNoSuch } from "../throwable/SimNoSuch.js";
import { getPostConstructs, getSim, Lifecycle, SimMetadataKey, sims } from "../decorators/SimDecorator.js";
import { ObjectUtils } from "@dooboostore/core";
import { SimAtomic } from "./SimAtomic.js";
import { ReflectUtils } from "@dooboostore/core";
import { getInject, isTargetFactory, isTargetScheme, isTargetSymbol, isTargetType, SituationTypeContainer, SituationTypeContainers } from "../decorators/inject/Inject.js";
import { SimOption } from "../SimOption.js";
import { SimProxyHandler } from "../proxy/SimProxyHandler.js";
import { ConvertUtils } from "@dooboostore/core";
import { isOnSimCreate } from "../lifecycle/OnSimCreate.js";
import { isOnSimCreateProxyCompleted } from "../lifecycle/OnSimCreateCompleted.js";
import { SimpleApplication } from "../SimpleApplication.js";
import { isSimNoProxy } from "../decorators/SimNoProxy.js";
import { RandomUtils } from "@dooboostore/core";
import { ValidUtils } from "@dooboostore/core";
class SimstanceManager {
  // private otherInstanceSim?: Map<ConstructorType<any> | Function, any>;
  constructor(simpleApplication, option) {
    this.simpleApplication = simpleApplication;
    this.option = option;
    this._storage = /* @__PURE__ */ new Map();
    this.name = "simstanceManager-" + RandomUtils.uuid4();
    this.setStoreSet(SimpleApplication, this.simpleApplication);
    this.setStoreSet(SimstanceManager, this);
    this.setStoreSet(option.constructor, option);
    this.setStoreSet(SimOption, option);
    this.simProxyHandler = new SimProxyHandler(this.simpleApplication, this, option);
  }
  get storage() {
    return this._storage;
  }
  getSimAtomics() {
    const r = [];
    Array.from(this.storage.entries()).forEach(([targetKeyType, targetMap]) => {
      r.push(
        ...Array.from(Array.from(targetMap.keys())).map(
          (sit) => new SimAtomic(
            {
              targetKeyType,
              originalType: sit
            },
            this
          )
        )
      );
    });
    return r;
  }
  getSimConfig(schemeOrSymbol) {
    const newVar = this.getSimAtomics().filter((it) => {
      const config = it?.getConfig();
      const symbols = ConvertUtils.flatArray(config?.symbol);
      const schemes = ConvertUtils.flatArray(config?.scheme);
      if (typeof schemeOrSymbol === "symbol") {
        return schemeOrSymbol && it && symbols.includes(schemeOrSymbol);
      } else if (typeof schemeOrSymbol === "string") {
        return schemeOrSymbol && it && schemes.includes(schemeOrSymbol);
      } else {
        return false;
      }
    }) || [];
    return newVar;
  }
  findSims(data) {
    let r = [];
    if (data) {
      const simAtomics = this.getSimAtomics();
      r = simAtomics.filter((it) => {
        let b = false;
        const config = it.getConfig();
        const symbols = ConvertUtils.flatArray(config?.symbol).filter(ValidUtils.isDefined);
        const schemes = ConvertUtils.flatArray(config?.scheme).filter(ValidUtils.isDefined);
        if (typeof data === "symbol") {
          b = symbols.includes(data);
        } else {
          const { scheme, type } = data;
          b = (scheme ? schemes.includes(scheme) : true) && (type ? it.type.targetKeyType === type : true);
        }
        return b;
      });
    }
    return r;
  }
  findFirstSim(data) {
    if (typeof data === "symbol") {
      return this.findSims(data)[0];
    } else {
      return this.findSims(data)[0];
    }
  }
  findLastSim(data) {
    if (typeof data === "symbol") {
      return this.findSims(data).reverse()[0];
    } else {
      return this.findSims(data).reverse()[0];
    }
  }
  flatStoreSets() {
    return new Map(
      Array.from(this.storage.values()).map((it) => Array.from(it.entries())).flat()
    );
  }
  getStoreSets(targetKey) {
    const map = this.storage.get(targetKey);
    const datas = (Array.from(map?.entries?.() ?? []) ?? []).reverse();
    return datas.map((it) => ({ type: it[0], instance: it[1] }));
  }
  getStoreSet(targetKey, target) {
    const sets = this.getStoreSets(targetKey);
    let find = sets.find((it) => it.type === target);
    if (!find && (!target || target === targetKey)) {
      find = sets.find((it) => it.instance);
    }
    if (!find?.instance) {
      const type = target ?? targetKey;
      if (typeof type === "object") {
        const find2 = this.storage.get(type);
        if (find2) {
          return { type, instance: type };
        }
      }
      const flatStoreSets = this.flatStoreSets();
      const data = flatStoreSets.get(type);
      if (data) {
        this.setStoreSet(targetKey, data, type);
      }
      return { type, instance: data };
    } else {
      return find;
    }
  }
  getStoreInstance(targetKey, target) {
    return this.getStoreSet(targetKey, target)?.instance;
  }
  getOrNewSim({ target, originTypeTarget = target, newInstanceCarrier }) {
    if (target) {
      const registed = this.getStoreSet(target, originTypeTarget);
      if (registed?.type && !registed?.instance) {
        return this.resolve({
          targetKey: target,
          target: originTypeTarget,
          newInstanceCarrier
        });
      }
      return registed?.instance;
    }
  }
  setStoreSet(targetKey, obj, target = targetKey) {
    const itemMap = this.storage.get(targetKey) ?? /* @__PURE__ */ new Map();
    itemMap.set(target, obj);
    this.storage.set(targetKey, itemMap);
  }
  registerStore(targetKey, regTyps) {
    const itemMap = this.storage.get(targetKey) ?? /* @__PURE__ */ new Map();
    regTyps.forEach((it) => {
      const { type, value } = ValidUtils.isArrowFunction(it) ? { type: it, value: it } : typeof it === "object" ? { type: it.constructor, value: it } : { type: it, value: void 0 };
      if (!itemMap.has(type) || value !== void 0 && itemMap.get(type) === void 0) {
        itemMap.set(type, value);
      }
    });
    this.storage.set(targetKey, itemMap);
  }
  // 진입점
  resolve({ target, targetKey, newInstanceCarrier = { newInstances: [], depth: 0 } }) {
    const registed = this.getStoreSet(targetKey, target);
    if (registed?.instance) {
      return registed.instance;
    }
    if (this.storage.has(targetKey) && void 0 === registed?.instance) {
      const resolving = newInstanceCarrier.resolving ??= [];
      if (resolving.includes(targetKey)) {
        const nameOf = (t) => typeof t === "symbol" ? t.toString() : t?.name ?? String(t);
        throw new Error(
          `Circular dependency detected: ${[...resolving.map(nameOf), nameOf(targetKey)].join(" -> ")}`
        );
      }
      resolving.push(targetKey);
      let settled = false;
      try {
        newInstanceCarrier.depth++;
        const newSim = this.newSim({
          target: registed?.type ?? targetKey,
          newInstanceCarrier,
          simCreateAfter: (data) => {
            if (getSim(registed?.type ?? target ?? targetKey)?.scope === Lifecycle.Singleton) {
              this.setStoreSet(targetKey, data, target);
            }
          }
        });
        newInstanceCarrier.depth--;
        resolving.pop();
        settled = true;
        if (newInstanceCarrier.depth === 0) {
          newInstanceCarrier.newInstances.forEach((it) => {
            this.callBindPostConstruct(it);
          });
        }
        if (isOnSimCreate(newSim)) {
          newSim.onSimCreate();
        }
        return newSim;
      } finally {
        if (!settled) {
          newInstanceCarrier.depth--;
          const idx = resolving.lastIndexOf(targetKey);
          if (idx !== -1) resolving.splice(idx, 1);
        }
      }
    }
    const simNoSuch = new SimNoSuch("SimNoSuch: no simple instance(resolve) name:" + targetKey?.prototype?.constructor?.name + "," + targetKey);
    console.error(simNoSuch);
    throw simNoSuch;
  }
  newSim({ target, simCreateAfter, otherStorage, newInstanceCarrier }) {
    const parameters = this.getParameterSim({
      target,
      otherStorage,
      newInstanceCarrier
    });
    const r = ValidUtils.isFunctionType(target) && !target.prototype ? target(...parameters) : new target(...parameters);
    let p = this.proxy(r);
    const config = getSim(target);
    if (config?.proxy) {
      const proxys = (Array.isArray(config.proxy) ? config.proxy : [config.proxy]).filter(ValidUtils.isDefined);
      proxys.forEach((it) => {
        if (typeof it === "object") {
          p = new Proxy(p, it);
        } else {
          const simConfig = getSim(it);
          p = new Proxy(p, simConfig ? this.getOrNewSim({ target: it }) : this.newSim({ target: it }));
        }
      });
    }
    newInstanceCarrier?.newInstances.push(p);
    simCreateAfter?.(p);
    if (isOnSimCreateProxyCompleted(p)) {
      p.onSimCreateProxyCompleted(p);
    }
    return p;
  }
  callBindPostConstruct(obj) {
    const postConstruct = getPostConstructs(obj);
    postConstruct.forEach((it) => {
      obj[it.property](...this.getParameterSim({ target: obj, targetKey: it.property }));
    });
  }
  async executeBindParameterSimPromise({ target, targetKey, firstCheckMaker, parameterCount, inputParameters }, otherStorage) {
    const binds = this.getParameterSim({ target, targetKey, firstCheckMaker, otherStorage, parameterCount, inputParameters });
    const resolvedBinds = await Promise.all(binds);
    if (typeof target === "object" && targetKey) {
      const targetMethod = target[targetKey];
      return targetMethod?.bind(target)?.(...resolvedBinds);
    } else if (typeof target === "function" && !targetKey) {
      return new target(...resolvedBinds);
    }
  }
  executeBindParameterSim({ target, targetKey, firstCheckMaker, parameterCount, inputParameters }, otherStorage) {
    const binds = this.getParameterSim({ target, targetKey, firstCheckMaker, otherStorage, parameterCount, inputParameters });
    if (typeof target === "object" && targetKey) {
      const targetMethod = target[targetKey];
      return targetMethod?.bind(target)?.(...binds);
    } else if (typeof target === "function" && !targetKey) {
      return new target(...binds);
    }
  }
  getParameterSim({ target, targetKey, firstCheckMaker, otherStorage, newInstanceCarrier, parameterCount, inputParameters = [] }) {
    const paramTypes = ReflectUtils.getParameterTypes(target, targetKey) || [];
    let injections = [];
    const injects = getInject(target, targetKey);
    const loopCount = Math.max(paramTypes.length, parameterCount ?? 0, ...(injects ?? []).map((it) => it.index + 1));
    injections = [];
    for (let idx = 0; idx < loopCount; idx++) {
      const token = paramTypes[idx];
      const saveInject = injects?.find((it) => it.index === idx);
      let isFirstChecked = false;
      for (const f of firstCheckMaker ?? []) {
        const firstCheckObj = f({ target, targetKey }, token, idx, saveInject);
        if (void 0 !== firstCheckObj) {
          injections.push(firstCheckObj);
          isFirstChecked = true;
          break;
        }
      }
      if (isFirstChecked) continue;
      if (saveInject) {
        const inject = saveInject.config;
        let obj = otherStorage?.get(token);
        if (token === Array && (isTargetType(inject) || isTargetScheme(inject) || isTargetSymbol(inject))) {
          const p = [];
          if (isTargetType(inject) && inject.type) {
            p.push(
              ...this.getStoreSets(inject.type).map(
                (it) => this.resolve({
                  targetKey: inject.type,
                  target: it.type,
                  newInstanceCarrier
                })
              ).reverse()
            );
          }
          if (isTargetSymbol(inject)) {
            p.push(...this.getSimConfig(inject.symbol).map((it) => it.getValue({ newInstanceCarrier })));
          }
          if (isTargetScheme(inject)) {
            p.push(...this.getSimConfig(inject.scheme).map((it) => it.getValue({ newInstanceCarrier })));
          }
          injections.push(p);
          continue;
        }
        if (inject.situationType && otherStorage) {
          const situations = otherStorage.get(SituationTypeContainers);
          const situation = otherStorage.get(SituationTypeContainer);
          if (inject.situationType === situation?.situationType) {
            obj = situation.data;
          } else if (situations && situations.length > 0) {
            const find = situations.find((a) => {
              if (a.index !== void 0) {
                return a.situationType === inject.situationType && a.index === idx;
              } else {
                return a.situationType === inject.situationType;
              }
            });
            if (find) {
              obj = find.data;
            }
          }
        }
        if (!obj) {
          const currentInstance = typeof target === "object" ? target : void 0;
          if (isTargetFactory(inject)) {
            const combinedParameters = injections.length > 0 ? injections : inputParameters;
            obj = inject.factory({
              instance: currentInstance,
              methodName: String(targetKey),
              parameter: combinedParameters,
              application: this.simpleApplication
            });
          } else {
            let findLastSim;
            if (isTargetSymbol(inject)) {
              findLastSim = this.findLastSim(inject.symbol);
            } else if (isTargetType(inject) || isTargetScheme(inject)) {
              findLastSim = this.findLastSim(inject);
            }
            try {
              obj = findLastSim ? this.resolve({
                targetKey: findLastSim?.type.targetKeyType ?? token,
                newInstanceCarrier
              }) : this.resolve({
                targetKey: token,
                newInstanceCarrier
              });
              if (inject.factory && obj) {
                if (typeof inject.factory === "function") {
                  const combinedParameters = injections.length > 0 ? injections : inputParameters;
                  obj = inject.factory({
                    instance: currentInstance,
                    methodName: String(targetKey),
                    parameter: combinedParameters,
                    application: this.simpleApplication,
                    injectInstance: obj
                  });
                }
              }
            } catch (e) {
              if (inject.optional) {
                injections.push(void 0);
                continue;
              } else {
                throw e;
              }
            }
          }
        }
        if (inject.proxy && obj) {
          if (ValidUtils.isClassType(inject.proxy)) {
            const handler = getSim(inject.proxy) ? this.getOrNewSim({ target: inject.proxy }) : new inject.proxy();
            if (handler) {
              obj = new Proxy(obj, handler);
            }
          } else if (typeof inject.proxy === "function") {
            const handler = inject.proxy({
              application: this.simpleApplication,
              instance: obj
            });
            if (handler) {
              obj = new Proxy(obj, handler);
            }
          }
        }
        injections.push(obj);
      } else {
        const obj = otherStorage?.get(token) ?? (token ? this.resolve({ targetKey: token, newInstanceCarrier }) : void 0);
        injections.push(obj);
      }
    }
    return injections;
  }
  proxy(target) {
    try {
      const noProxy = isSimNoProxy(target);
      const isExcludeProxy = this.option.excludeProxys?.some((it) => target instanceof it);
      if (!noProxy && !isExcludeProxy && target !== null && getSim(target) && typeof target === "object" && !("_SimpleBoot_isProxy" in target)) {
        for (const key in target) {
          if (!isSimNoProxy(target, key)) {
            target[key] = this.proxy(target[key]);
          }
        }
        const protoTypeName = ObjectUtils.ownPropertyNames(target);
        protoTypeName.filter((it) => typeof target[it] === "function").filter((it) => !isSimNoProxy(target, it)).filter((it) => !("_SimpleBoot_isProxy" in target[it])).forEach((it) => {
          target[it] = new Proxy(target[it], this.simProxyHandler);
        });
        if (this.simProxyHandler) {
          target = new Proxy(target, this.simProxyHandler);
        }
      }
      if (this.option.proxy) {
        target = this.option.proxy.onAfterProxy(target);
      }
      return target;
    } catch (e) {
      console.log("sim proxy error");
      throw e;
    }
  }
  run(otherInstanceSim = /* @__PURE__ */ new Map()) {
    for (const [k, v] of Array.from(otherInstanceSim.entries())) {
      const hasType = typeof k === "object" && k !== null && "type" in k;
      const hasSymbol = typeof k === "object" && k !== null && !!k.symbol;
      const storageKey = hasType ? k.type : k;
      if (hasType || !hasSymbol) {
        this.registerStore(storageKey, /* @__PURE__ */ new Set([v]));
      }
      if (hasSymbol) {
        if (!ReflectUtils.getMetadata(SimMetadataKey, v)) {
          ReflectUtils.defineMetadata(SimMetadataKey, { ...k, scope: k.scope ?? Lifecycle.Singleton }, v);
        }
        this.registerStore(k.symbol, /* @__PURE__ */ new Set([v]));
      }
    }
    const myContainers = ConvertUtils.flatArray(this.option.container).filter(ValidUtils.isDefined);
    if (!myContainers.includes(this.simpleApplication)) {
      myContainers.push(this.simpleApplication);
    }
    Array.from(sims.entries()).forEach(([type, implementations]) => {
      const filteredSet = /* @__PURE__ */ new Set();
      implementations.forEach((impl) => {
        const config = getSim(impl);
        const targetContainers = ConvertUtils.flatArray(config?.container).filter(ValidUtils.isDefined);
        let isInclude = false;
        if (targetContainers.length <= 0) {
          if (myContainers.length === 1 && myContainers[0] === this.simpleApplication) {
            isInclude = true;
          }
        } else {
          isInclude = myContainers.some((it) => targetContainers.includes(it));
        }
        if (isInclude) {
          filteredSet.add(impl);
        }
      });
      if (filteredSet.size > 0) {
        this.registerStore(type, filteredSet);
      }
    });
    this.callBindPostConstruct(this);
    this.getSimAtomics().forEach((it) => {
      if (it.getConfig()?.autoCreate) {
        it.getValue();
      }
    });
  }
}
export {
  SimstanceManager
};
//# sourceMappingURL=SimstanceManager.js.map
